export default __webpack_public_path__ + "images/b6c5596d41663ceec26b49f432ff7ffa.svg";